<template>
  <div
    class="auth-content"
    :class="{ 'auth-content--blurred': isOpenMobileSidebarLeft || isOpenMobileSidebarRight }"
  >
    <ImpersonnalisationView v-if="enImpersonalisation" />
    <h1 v-else-if="enAuthentification">Authentification ...</h1>
    <slot v-else></slot>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useAuthentificationStore } from '..'
  import { AuthAktoEtats } from '../modeles/AuthState'
  import ImpersonnalisationView from '../../impersonnalisation/views/ImpersonnalisationView.vue'
  import { useSidebarStateStore } from '@/features/interface/layout/sideBar/useSideBarStore'
  import { storeToRefs } from 'pinia'

  const authStore = useAuthentificationStore()

  const enAuthentification = computed(() => {
    return [AuthAktoEtats.Authentifié, AuthAktoEtats.NonAuthentifié].includes(authStore.etat) === false
  })

  const enImpersonalisation = computed(() => {
    return [AuthAktoEtats.EnImpersonnalisation].includes(authStore.etat)
  })

  const sidebarStateStore = useSidebarStateStore()

  const { isOpenMobileSidebarLeft, isOpenMobileSidebarRight } = storeToRefs(sidebarStateStore)
</script>
<style scoped lang="less">
  .auth-content {
    flex: 1;
    z-index: 0;
    background-color: @neutral-0;
    padding: clamp(16px, 4vw, 24px) clamp(16px, 4vw, 48px);
    overflow-x: hidden;
  }

  @media (max-width: @breakpoint-mobile) {
    .auth-content--blurred {
      filter: blur(2px);
      pointer-events: none;
      user-select: none;
      transition: filter 0.2s;
    }
  }
</style>
